module.exports = __webpack_public_path__ + "img/p4.c3600a55.png";